import { render } from "./PackagesFromStock.vue?vue&type=template&id=209efdb2"
import script from "./PackagesFromStock.vue?vue&type=script&lang=js"
export * from "./PackagesFromStock.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/models/package.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fcomponents%2Fviews%2Fpacking_house%2Fproduction%2Fpalletized%2Fshow_process%2FPackagesFromStock.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/views/packing_house/production/palletized/show_process.yml?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fcomponents%2Fviews%2Fpacking_house%2Fproduction%2Fpalletized%2Fshow_process%2FPackagesFromStock.vue&lang=yaml"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__